import { formatRelative } from './format.js';

export const NEEDS_ATTENTION_REASONS = {
  failed_text: {
    key: 'failed_text',
    label: 'Text failed',
    helper: 'A campaign or manual text failed. Review before retrying.',
    variant: 'danger',
  },
  missing_phone: {
    key: 'missing_phone',
    label: 'Missing phone',
    helper: 'No usable phone number is available for outreach.',
    variant: 'warning',
  },
  reply_needs_scheduling: {
    key: 'reply_needs_scheduling',
    label: 'Needs interview',
    helper: 'Applicant replied and has no scheduled interview.',
    variant: 'info',
  },
  no_show_followup: {
    key: 'no_show_followup',
    label: 'No-show follow-up',
    helper: 'Applicant missed an interview and needs a decision.',
    variant: 'warning',
  },
  stale_no_response: {
    key: 'stale_no_response',
    label: 'Stale no-response',
    helper: 'No reply after follow-up window.',
    variant: 'warning',
  },
  campaign_skipped: {
    key: 'campaign_skipped',
    label: 'Campaign skipped',
    helper: 'Campaign did not start for this applicant.',
    variant: 'neutral',
  },
  import_error: {
    key: 'import_error',
    label: 'Import error',
    helper: 'Import row needs review.',
    variant: 'danger',
  },
};

export const NEEDS_ATTENTION_FILTERS = [
  { label: 'All', value: '' },
  { label: 'Text failed', value: 'failed_text' },
  { label: 'Missing phone', value: 'missing_phone' },
  { label: 'Needs interview', value: 'reply_needs_scheduling' },
  { label: 'No-show follow-up', value: 'no_show_followup' },
  { label: 'Stale no-response', value: 'stale_no_response' },
  { label: 'Campaign skipped', value: 'campaign_skipped' },
];

export const NEEDS_ATTENTION_COUNT_KEYS = [
  'total',
  'failed_text',
  'missing_phone',
  'reply_needs_scheduling',
  'no_show_followup',
  'stale_no_response',
  'campaign_skipped',
  'import_error',
];

const DEFAULT_REASON = {
  label: 'Needs review',
  helper: 'Dispatcher review is needed before automation can continue.',
  variant: 'warning',
};

export function getNeedsAttentionReason(reasonKey, backendHelper = '') {
  const reason = NEEDS_ATTENTION_REASONS[reasonKey] || DEFAULT_REASON;
  return {
    key: reasonKey || 'needs_review',
    label: reason.label,
    helper: backendHelper || reason.helper,
    variant: reason.variant,
  };
}

export function getNeedsAttentionCounts(counts = {}) {
  return NEEDS_ATTENTION_COUNT_KEYS.reduce((acc, key) => {
    acc[key] = Number.isFinite(Number(counts[key])) ? Number(counts[key]) : 0;
    return acc;
  }, {});
}

export function getNeedsAttentionRow(item = {}) {
  return {
    applicantId: item.applicantId,
    displayName: item.displayName || 'Applicant',
    stageLabel: item.stageLabel || '—',
    sourceLabel: item.sourceLabel || '—',
    reason: getNeedsAttentionReason(item.reasonKey, item.helper),
    nextActionLabel: item.nextActionLabel || 'Open applicant',
    nextActionUrl: item.nextActionUrl || (item.applicantId ? `/applicants/${item.applicantId}` : '/'),
    ageLabel: item.ageLabel || '—',
    lastTouchLabel: item.lastContactAt ? `Last touch ${formatRelative(item.lastContactAt)}` : 'No contact',
    nextInterviewLabel: item.nextInterviewAt ? formatRelative(item.nextInterviewAt) : '—',
  };
}

export function buildNeedsAttentionQuery({ reason = '', page = 1, limit = 25 } = {}) {
  const params = new URLSearchParams();
  if (reason) params.set('reason', reason);
  params.set('page', String(page || 1));
  params.set('limit', String(limit || 25));
  return params.toString();
}

export function getNeedsAttentionEmptyState() {
  return {
    title: 'Nothing needs attention',
    description: 'Automation is running normally and there are no exception items in this queue.',
    actionLabel: 'Back to applicants',
  };
}
